import {SECURE} from '../../namespace/secure/secure'
import {API} from '../../../../api/api'

export const secure = {
  state: {
    userData: null,
    authProcessStatus: true
  },
  mutations: {
    [SECURE.MUTATIONS.AUTH_IN_PROGRESS](state, status) {
      state.authProcessStatus = status
    },
    [SECURE.MUTATIONS.SET_USER_DATA](state, userData) {
      state.userData = {
        id: userData.id,
        first_name: userData.first_name,
        last_name: userData.last_name,
        braintree: userData.braintree,
        addresses: userData.addresses,
      }
    }
  },
  actions: {
    async [SECURE.ACTIONS.CHECK]({ commit }) {
      try {
        const response = await API.userAuthCheck()
        commit(SECURE.MUTATIONS.SET_USER_DATA, response.data.data)
        return response
      } catch (e) {
        console.warn(e)
        return false
      } finally {
        commit(SECURE.MUTATIONS.AUTH_IN_PROGRESS, false)
      }
    }
  },
  getters: {
    [SECURE.GETTERS.USER_DATA](state) {
      return state.userData
    },
    [SECURE.GETTERS.AUTH_IN_PROGRESS](state) {
      return state.authProcessStatus
    }
  }
}
